import React from 'react';

const HTMLReport = ({ report }: { report: string }) => (
  <div className="h-[calc(100vh-325px)] print:overflow-auto">
    <iframe srcDoc={report} title="Report preview" className="h-full min-w-full p-8" />
  </div>
);

export default HTMLReport;
